import { render, staticRenderFns } from "./AddEditRules.vue?vue&type=template&id=3e6c039a"
import script from "./AddEditRules.vue?vue&type=script&lang=js"
export * from "./AddEditRules.vue?vue&type=script&lang=js"
import style0 from "./AddEditRules.vue?vue&type=style&index=0&id=3e6c039a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports